import { cropNumber } from "../../../../common/helpers/helpers";

export const getValueFromType = (index, displayFields) => {
  let value = null;
  const valueType = typeof displayFields[index];

  switch (valueType) {
    case "number":
      value = cropNumber(displayFields[index]);
      break;
    case "boolean":
      value = displayFields[index].toString();
      break;
    default:
      value = displayFields[index];
      break;
  }
  return value;
};

export const checkIfDbNSFPGenesEmpty = (obj) => {
  let isEmpty = true;
  for (const key in obj) {
    if (key !== "kegg" && key !== "expressions_rpkm" && key !== "gene_symbol") {
      if (obj[key] !== null && obj[key] !== "") {
        isEmpty = false;
        break;
      }
    }

    // For kegg previous thalia version returns empty arrays while new returns null.
    // kegg: {id: [], full: []} or kegg: null
    // For expressions_rpkm previous thalia version returns empty object while new returns null.
    // expressions_rpkm: {} or expressions_rpkm: null
    if (isEmpty === true && (key === "expressions_rpkm" || key === "kegg")) {
      if (obj[key] !== null && JSON.stringify(obj[key]) !== "{}") {
        if (key === "kegg") {
          for (const k in obj[key]) {
            if (obj[key][k].length && obj[key][k].length > 0) {
              isEmpty = false;
              break;
            }
          }
        } else {
          isEmpty = false;
        }
      }
    }
  }

  return isEmpty;
};
